<div class="between-center">
    <h1 class="page-title">User Audit Log</h1>
</div>
<form [formGroup]="form">
    <div class="audit-log-search-controls">
        <synx-date-time-input
            formControlName="logDateRange"
            [maxDate]="maxDate"
            [format]="'datetimerange'"
            [isDateRange]="true"
            style="width: 19%;">
        </synx-date-time-input>
        <div class="audit-log-filters">
            <synx-multi-select-dropdown formControlName="users"
                [selectOptions]="userOptions" [searchEnableFlag]="true"
                [placeholder]="'All Users'">
            </synx-multi-select-dropdown>
            <synx-multi-select-dropdown formControlName="assets"
                [selectOptions]="assetOptions" [searchEnableFlag]="true"
                [placeholder]="'All Assets'" [showSelectAllFlag]="false">
            </synx-multi-select-dropdown>
            <synx-multi-select-dropdown formControlName="activities"
                [selectOptions]="activityOptions" [searchEnableFlag]="true"
                [placeholder]="'All Activities'">
            </synx-multi-select-dropdown>

                <p
                    *ngIf="form.dirty"
                    class="reset-button"
                    (click)="resetFilters()"
                >
                    Reset
                </p>
        </div>
        <div class="audit-log-options">
            <synx-checkbox
                class="info-box-checkbox"
                checkboxLabel="Group by Session"
                [labelFontSize]="0.875"
                [checked]="isGrouped"
                (checkedChange)="toggleIsGrouped()"
            ></synx-checkbox>
            <button (click)="search()" class="default-custom-button  add-button custom-button custom-button-flat">
            Search
            </button>
        </div>
    </div>
</form>
<audit-logging-table
    [data]="auditLogs"
    [pageSize]="100"
    [isGrouped]="isGrouped"
    (openUrlEvent)="openUrl($event)"
></audit-logging-table>
